export default __webpack_public_path__ + "e433cbb7e77f013a55b37a7aa884f6f3.png";